import type { SymbolDefinition } from "../types.ts";

export const rcd: SymbolDefinition = {
  id: "ep-rcd",
  familyKey: "rcd",
  deviceKind: "circuit_breaker",
  version: "0.1.0",
  label: { sv: "Jordfelsbrytare", en: "RCD" },
  description: { sv: "Jordfelsbrytare.", en: "Residual current device." },
  viewBox: "0 0 48 48",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <rect x="6" y="14" width="36" height="20" rx="2"/>
      <line x1="8" y1="4" x2="8" y2="14"/>
      <line x1="20" y1="4" x2="20" y2="14"/>
      <line x1="28" y1="4" x2="28" y2="14"/>
      <line x1="40" y1="4" x2="40" y2="14"/>
      <line x1="8" y1="34" x2="8" y2="44"/>
      <line x1="20" y1="34" x2="20" y2="44"/>
      <line x1="28" y1="34" x2="28" y2="44"/>
      <line x1="40" y1="34" x2="40" y2="44"/>
      <text x="24" y="28" text-anchor="middle" font-size="8" fill="currentColor" stroke="none">I△</text>
    </g>
  `,
  terminals: [
    { id: "L1-in", kind: "phase", label: "L1", position: "top", offset: 0.167 },
    { id: "L2-in", kind: "phase", label: "L2", position: "top", offset: 0.417 },
    { id: "L3-in", kind: "phase", label: "L3", position: "top", offset: 0.583 },
    { id: "N-in", kind: "neutral", label: "N", position: "top", offset: 0.833 },
    { id: "T1-out", kind: "phase", label: "T1", position: "bottom", offset: 0.167 },
    { id: "T2-out", kind: "phase", label: "T2", position: "bottom", offset: 0.417 },
    { id: "T3-out", kind: "phase", label: "T3", position: "bottom", offset: 0.583 },
    { id: "N-out", kind: "neutral", label: "N", position: "bottom", offset: 0.833 },
  ],
  designationPrefix: "Q",
  searchKeywords: ["jordfelsbrytare", "rcd", "jordfel"],
};
